export const signupMultiLang = (language) => {

    if(language === "en-US") {
        return {
            "landingImgTxt" : "Community Supported Agriculture (CSA) programs provide SNAP customers with fresh, nutritious fruits and vegetables while supporting local farmers. DTA works together with local farmers to offer SNAP customers an easy way to pay for fruits and vegetables automatically from your SNAP account each month on the day you get your benefit. For information on how to enroll in a CSA, press the Learn More button below.",
            "EnrollCSA" : "Enroll in a CSA Share",
            "CancelCSA" : "Cancel your CSA Share",
            "learnMore" : "Learn More",
            "farmInfo" : "Farm Information",
            "clientInfo" : "Client Information",
            "snapCSA" : "SNAP CSA Share",
            "pickupDelivery": "Pickup/Delivery Location",
            "signAndSubmit" : "Sign & Submit",
            "chooseFarm" : "Choose Farm",
            "select" : "Select",
            "Notes about our CSA": "Notes about our CSA",
            "Website" : "Website",
            "Next" : "Next",
            "Prev" : "Prev",
            "firstName" : "First Name (as listed on your SNAP case)",
            "lastName": "Last Name (as listed on your SNAP case)",
            "chosenName": "Preferred/Chosen First Name",
            "dateOfBirth": "Date of Birth",
            "month": "Month",
            "day": "Day",
            "year" : "Year",
            "ebtCardAgencyId": "EBT Card Number / DTA Agency ID",
            "email": "Email",
            "phone" : "Phone (include area code)",
            "cancelShareAgreement" : "CANCEL CSA SHARE AGREEMENT",
            "sorryToGo" : "We are sorry to see you go",
            "pleaseProvide" : "Please provide the following information to cancel your CSA agreement",
            "cancelFirstName": "First Name",
            "cancelLastName" : "Last Name",
            "ebtCard": "EBT Card Number",
            "agencyId" : "DTA Agency ID",
            "submit" : "Submit",
            "anyQuestions" : "If you have any questions, please contact the farm directly.",
            "cancelError": " is required",
            "cancelFirstNameError": "First Name is required",
            "cancelLastNameError": "Last Name is required",
            "cancelMonthError": "Month is required",
            "cancelDateError": "Date is required",
            "cancelYearError": "Year is required",
            "cancelEbtCardAgencyIdError": "EBT Card Number/DTA Agency ID is required",
            "cancelEbtCardError": "EBT Card Number is required",
            "cancelAgencyIdError": "DTA Agency ID is required",
            "details": "Details",
            "vendorName": "Vendor Name",
            "agreementStatus" : "Agreement Status",
            "shareName" : "Share Name",
            "expiresOn" : "Expires On",
            "amount" : "Amount",
            "cancel" : "Cancel",
            "monthly" : "Monthly",
            "daily" : "Daily",
            "January": "January",
            "February": "February",
            "March" : "March",
            "April" : "April",
            "May" : "May",
            "June" : "June",
            "July" : "July",
            "August" : "August",
            "September" : "September",
            "October" : "October",
            "November" : "November",
            "December" : "December",
            "Change in Benefit Amount" : "Change in Benefit Amount",
            "Change share type" : "Change share type",
            "Cancelled due to HIP Suspension" : "Cancelled due to HIP Suspension",
            "No reason given": "No reason given",
            "Transportation/Medical Issues": "Transportation/Medical Issues",
            "Unsatisfied with share" : "Unsatisfied with share",
            "Other Reason" : "Other Reason",
            "Reason for cancellation": "Reason for cancellation",
            "pleaseChooseTheReason" : "Please choose the reason",
            "farmError" : "Please select a Farm to proceed",
            "signupDateOfBirthError" : "Please enter Date of Birth",
            "signupFirstNameError" : "Please enter First Name",
            "signupLastNameError" : "Please enter Last Name",
            "signupAgencyIdError" : "Please enter DTA Agency ID",
            "signupEBTCardError" : "Please enter EBT Card Number ",
            "signupPhoneError" : "Please enter Primary Phone Number",
            "csaSignup" : "CSA SIGNUP",
            "preferNameMoreInfo" : "Name you prefer the vendor to call you maybe same or different than first name on SNAP case",
            "contactInfoMoreInfo" : "The contact information you provide here will be shared with the CSA farm for the farm to communicate with you about your CSA signup request. DTA will not use this information to update your primary DTA account. To update your primary DTA account, please log into ",
            "howToUseThisPage" : "How to use this page",
            "snapCSAWorks" : "See how a SNAP CSA works",
            "snapCSAComboBox" : "The SNAP CSA Pilot lets you signup for a monthly subscription to a local farm using your SNAP benefits. The farm decides what fruits and/or vegetables to provide and how often. The produce you get is called a CSA share. You pay with SNAP automatically each month based on the CSA share you choose. SNAP stands for Supplemental Nutrition Assistance Program. CSA stands for Community Supported Agriculture.",
            "hipComboBox" : "If you see a HIP amount below, the farm you chose participates in HIP. HIP stands for the Healthy Incentives Program. HIP will give you SNAP back, up to the HIP amount shown below, when you make each monthly SNAP CSA payment. To learn more about HIP visit",
            "EstimatedComboBox": "The CSA payment dates and start month are calculated using today's date. These might both change if the farm needs more time to process your request.",
            "RequestHelpPopup" : "We have captured the information you entered so far. In some cases, you will not be able to finish this CSA request online. Pick “yes” to get help from DTA and we will contact you in the next few business days. Pick “no” to return to the form",
            "SnapCSAButton" : "SNAP CSA",
            "HIPButton" : "HIP",
            "EstimatedButton" : "Estimated",
            "RequestButton" : "Request Help",
            "Yes" : "Yes",
            "No" : "No",            
            "IfTheFarmSays" : "If the farm says yes to your CSA request, DTA will send you a SNAP CSA Approval Notice with your actual payment dates. SNAP CSA payments begin before you start receiving your CSA share. The payment dates shown below for each CSA share are", 
            "YourSnapMonthlyAmount": "Your SNAP Monthly Amount ",
            "YourHIPMontlhyCap" : "Your HIP Monthly Cap ",
            "PleaseCheckOff" : "Please check off the CSA option you wish to purchase",
            "ShareDetails" : "Share Details",
            "CSAStartMonth" :"CSA Start Month: ",
            "CSAEndMonth" :"CSA End Month: ",
            "MonthlyShareCost" : " Monthly Share Cost: ",
            "YourCSAPaymentSchedule" : "Your CSA Payment Schedule",
            "PaymentDate" : "Payment Date",
            "PaymentAmount" : "Payment Amount",
            "overAllCost" : "Overall Cost",
            "upcomingMonthlyCSA" : "Upcoming Monthly CSA Payment Total",
            "amountOfHIP" : "Amount of HIP you'll get back",
            "amountOfHIPMoreInfo" : "HIP will reimburse this amount each month that you have HIP available. Learn more at mass.gov/hip.",
            "snapShareErroMsg" : "Please choose the CSA Share you would like to purchase",
            "payWithSNAP": "Pay with SNAP",
            "payWithSNAPHIP" : "Pay with SNAP/HIP",
            "share" : "Share",
            "PickupLocation" : "Pick up location",
            "ChoosePickupLocation" : "Choose a Pickup Location",
            "PleasechoosePickupLocation" : "Please choose a Pickup Location",
            "DeliveryLocation" : "Delivery Location",
            "DeliveryRange" : "Delivery Range",
            "AddressLine1" : "Address Line 1",
            "AddressLine2" : "Address Line 2",
            "City" : "City",
            "State" : "State",
            "Zipcode": "Zip Code",
            "CSARights" : "CSA Rights and Responsibilities",
            "IHaveReadTheTerms" : "I have read the terms and Conditions",
            "PleaseCheckTermsError" : "Please check the terms and conditions",
            "Date" : "Date",
            "ClientSignature" : "Client Signature",
            "SignatureErrorMsg" : "Client signature required",
            "SubmitApplication" : "Submit application",
            "YourCSASignupRequest" : "Your CSA Signup Request Form has been submitted to the farm for approval!",
            "TheFarmAndDTA" : "The farm and DTA will review your request. Once the request is processed, you will receive notification.",
            "GoToHomePage" : "Go To Home Page",
            "AgreementId" : "Agreement Id :",
            "ThePaymentScheduleShown" : "The payment schedule shown to me so far is estimated. My payment schedule and CSA start date might change if the farm needs more time to process my CSA request.",
            "TheFarmDecidesWhether" : "The farm decides whether to approve my CSA request. If the farm approves, I will receive a notice that shows my actual payment schedule. The notice serves as my receipt.",
            "BenefitsWillBe" : "Benefits will be automatically deducted from my SNAP balance according to my payment schedule. If Healthy Incentives Program (HIP) money is available for my CSA share purchase, that amount will be automatically added back to my SNAP balance.",
            "MysignupInformation" : "My sign-up information and the status of my payments will be shared with the farm. The farm may contact me using the information I have provided on this CSA request.",
            "IAmResponsible" : "I am responsible for picking up my CSA share on the dates and times determined by the farm or having someone pick it up for me. Pick up locations, dates, and times are subject to change by the farm. CSA shares that are not picked up will be donated, and I will not get a refund. Any arrangements for delivery must be made through the farm." ,
            "TheType" : "The type, weight and quantity of produce will vary weekly, and I cannot return my CSA share for a refund or exchange.",
            "IfMySNAP" : "If my SNAP benefit amount decreases and will no longer cover the full cost of my CSA share, it is my responsibility to inform the farm. If I choose to continue with the CSA share, I can arrange for an alternative payment method to cover the difference.",
            "CSAShareDetails" : "CSA share details and my CSA customer experience are managed by the farm. If have questions about these, I can contact the farm. DTA has the right to cancel my CSA share at the farm’s request.",
            "IMayCancel" : "I may cancel my CSA share at any time by:",
            "Submitting" : "Submitting a cancellation on DTAFinder.com",
            "Calling" : "calling the HIP/CSA line at 413-772-3411",
            "CancellationsMust" : "Cancellations must be received by the 20th of the month to be effective for the following month. Otherwise, the cancellation may not occur until the month thereafter.",
            "IMayBeAsked" : "I may be asked to complete a brief survey about the SNAP CSA Pilot.",
            "cancelCSAAgreement" : "CANCEL CSA AGREEMENT",
            "signature" : "Signature",
            "cancelSignatureErrMsg" : "Please enter your Signature",
            "noteForCancelCSA" : "Note: Selected shares under this agreement will be cancelled",
            "description": "Description",
            "WeightAmountOfGoods" :"Weight/Amount of Goods",
            "PickupDayTime" : "Pickup Day/Time",
            "validDayError":"Please enter a valid day between 1 and 31 ",
            "validYearError": "Please enter a valid year",
            "PickA": "Pick a",
            "shareBelow" : "share below. This page shows how much SNAP and",
            "youGetEachMonth" : "you get each month that could be used for a monthly SNAP CSA payment.",
            "IfYouNeedHelp": "If you need help, you can ask us to give you a call to continue the CSA request over the phone.",
            "ThisPaymentSchedule": "This payment schedule is estimated based on today's date.The CSA start date and payment schedule might happen later if the farm needs more time to process your CSA request.",
            "SelectPickupTime":"Select a Pick-up time",
            "Your":"Your",
            "YouMay":"You may want to ",
            "download":"download your agreement",
            "reference":" for future reference.",


        }   
    }else if(language === "es-ES") {
        return {
            "landingImgTxt" : "Los programas de Agricultura Apoyada por la Comunidad (CSA, por sus siglas en inglés) le proporcionan a los usuarios del SNAP frutas y vegetales frescos y nutritivos, y a la vez apoyan a los agricultores locales. El Departamento de Asistencia Temporal (DTA, por sus siglas en inglés) trabaja junto a los granjeros locales para ofrecer a los usuarios del Programa de Asistencia Nutricional Suplementaria (SNAP, por sus siglas en inglés) una forma sencilla de pagar por frutas y vegetales de forma automática desde su cuenta del SNAP, cada mes, el día que recibe sus beneficios. Para obtener información sobre cómo inscribirse en un CSA, presione el botón Más información a continuación.",
            "EnrollCSA" : "Inscríbase en CSA Share (Ración de CSA)",
            "CancelCSA" : "Cancele su Ración de CSA",
            "learnMore" : "Obtenga más información",
            "farmInfo"  : "Información sobre la granja",
            "clientInfo" : "Información del cliente",
            "snapCSA" : "Ración de SNAP CSA",
            "pickupDelivery": "Lugar de la recogida/entrega",
            "signAndSubmit" : "Firmar y presentar",
            "chooseFarm" : "Elija la granja",
            "select" : "Seleccione",
            "Notes about our CSA": "Notas sobre nuestro CSA",
            "Website" : "Sitio web",
            "Next" : "Siguiente",
            "Prev" : "Prev",
            "firstName" : "Nombre (como aparece en su caso del SNAP)",
            "lastName": "Apellido (como aparece en su caso del SNAP)",
            "chosenName": "Nombre preferido/elegido",
            "dateOfBirth": "Fecha de nacimiento",
            "month": "Mes",
            "day": "día",
            "year" : "año",
            "ebtCardAgencyId": "Número de tarjeta EBT / ID de agencia DTA",
            "email": "Correo electrónico",
            "phone" : "Teléfono (incluya el código de área)",
            "cancelShareAgreement" : "CANCELAR EL ACUERDO DE LA RACIÓN DE CSA",
            "sorryToGo" : "Lamentamos que se vaya",
            "pleaseProvide" : "Suministre la siguiente información para cancelar su acuerdo CSA",
            "cancelFirstName": "Nombre",
            "cancelLastName" : "Apellido",
            "ebtCard": "Número de tarjeta EBT",
            "agencyId" : "ID de agencia DTA",
            "submit" : "Enviar",
            "anyQuestions" : "Si tiene alguna pregunta, contacte directamente a la granja.",
            "cancelError": " es obligatorio",
            "cancelFirstNameError": "El nombre es obligatorio",
            "cancelLastNameError": "El apellido es obligatorio",
            "cancelMonthError": "El mes es obligatorio",
            "cancelDateError": "La fecha es obligatoria",
            "cancelYearError": " El año es obligatorio",
            "cancelEbtCardAgencyIdError": "El número de tarjeta de EBT / la ID de agencia DTA es obligatorio(a)",
            "cancelEbtCardError": "El número de tarjeta de EBT es obligatorio",
            "cancelAgencyIdError": "la ID de agencia DTA es obligatorio(a)",
            "details": "Detalles",
            "vendorName": "Nombre del proveedor ",
            "agreementStatus" : "Estado del acuerdo",
            "shareName" : "Nombre de la ración",
            "expiresOn" : "Vence el",
            "amount" : "El monto",
            "cancel" : "Cancelar",
            "monthly" : "Mensual",
            "daily" : "Diario",
            "January": "Enero",
            "February": "Febrero",
            "March" : "Marzo",
            "April" : "Abril",
            "May" : "Mayo",
            "June" : "Junio",
            "July" : "Julio",
            "August" : "Agosto",
            "September" : "Septiembre",
            "October" : "Octubre",
            "November" : "Noviembre",
            "December" : "Diciembre",
            "Change in Benefit Amount" : "Cambio en el monto del beneficio",
            "Change share type" : "Cambio en el tipo de ración",
            "Cancelled due to HIP Suspension" : "Cancelado debido a la suspensión del HIP",
            "No reason given": "No se indicó el motivo",
            "Transportation/Medical Issues": "Problemas de transporte/médicos",
            "Unsatisfied with share" : "Está insatisfecho con la Ración",
            "Other Reason" : "Otro motivo",
            "Reason for cancellation": "Motivo de la cancelación",
            "pleaseChooseTheReason" : "Por favor, elija el motivo",
            "farmError" : "Seleccione una granja y proceda",
            "signupDateOfBirthError" : "Ingrese la fecha de nacimiento",
            "signupFirstNameError" : "Ingrese su nombre",
            "signupLastNameError" : "Ingrese su apellido",
            "signupAgencyIdError" : "Ingrese la identificación de la agencia del DTA",
            "signupEBTCardError" : "Ingrese el número de tarjeta de EBT",
            "signupPhoneError" : "Ingrese el número de teléfono principal" ,
            "csaSignup" : "INSCRIPCIÓN EN LA CSA",
            "preferNameMoreInfo" : "Nombre por el que prefiere que el proveedor lo llame, quizá el mismo o distinto del nombre del caso del SNAP.",
            "contactInfoMoreInfo" : "La información de contacto que suministre será compartida con la granja CSA para que la granja se comunique con usted en relación a su solicitud de inscripción en el CSA. El DTA no usará esta información para actualizar su cuenta principal del DTA. Para actualizar su cuenta principal del DTA, inicie sesión a ",
            "howToUseThisPage" : "Cómo usar esta página",
            "snapCSAWorks" : "Vea cómo funciona un SNAP CSA",
            "snapCSAComboBox" : "El Piloto del SNAP CSA le permite inscribirse para una suscripción mensual a una granja local usando sus beneficios del SNAP. La granja decide qué frutas y/o vegetales suministrar y con qué frecuencia. Los productos agrícolas que reciba se denominan ración de CSA. Usted paga automáticamente, cada mes, con el SNAP en función de la ración de CSA que elija. SNAP son las siglas en inglés del Programa de Asistencia Nutricional Complementaria. CSA son las siglas en inglés del Programas de Agricultura Apoyada por la Comunidad.",
            "hipComboBox" : "Si ve un monto de HIP a continuación, la granja que eligió participa en el HIP. HIP son las siglas en inglés del Programa de Incentivos Saludables. El HIP le devolverá el SNAP, hasta el monto de HIP mostrado a continuación, cuando realice cada pago mensual de SNAP CSA. Para obtener más información sobre el HIP visite",
            "EstimatedComboBox": "Las fechas de pago de CSA y el mes de inicio se calculan usando la fecha de hoy. Ambas pueden cambiar si la granja necesita más tiempo para procesar su solicitud.",
            "RequestHelpPopup" : "Hemos registrado la información que ha ingresado hasta ahora. En algunos casos, podrá finalizar esta solicitud de CSA en línea. Elija «sí» para obtener información de parte del DTA y nos comunicaremos con usted en los próximos días laborables. Elija «no» para regresar al formulario.",
            "SnapCSAButton" : "SNAP CSA",
            "HIPButton" : "HIP",
            "EstimatedButton" : "Estimado",
            "RequestButton" : "Solicite ayuda",
            "Yes" : "Sí",
            "No" : "NO",   
            "IfTheFarmSays" : "Si la granja aprueba su solicitud de CSA, el DTA le enviará una Notificación de aprobación del SNAP CSA con sus fechas de pago reales. Los pagos de SNAP CSA inician antes de que empiece a recibir su ración de CSA. Las fechas de pago mostradas a continuación para cada ración de CSA son ", 
            "YourSnapMonthlyAmount": "Su monto mensual del SNAP",
            "YourHIPMontlhyCap" : "Su monto máximo mensual de HIP",
            "PleaseCheckOff" : "Por favor, marque la opción de CSA que desea comprar",
            "ShareDetails" : "Detalles de la ración",
            "CSAStartMonth" :"Mes de inicio de CSA: ",
            "CSAEndMonth" :"Mes de finalización de CSA: ",
            "MonthlyShareCost" : " Costo de la ración mensual: ",
            "YourCSAPaymentSchedule" : "Su programa de pago de CSA",
            "PaymentDate" : "Fecha de pago",
            "PaymentAmount" : "Monto del pago",
            "overAllCost" : "Costo general",
            "upcomingMonthlyCSA" : "Total del próximo pago mensual de CSA",
            "amountOfHIP" : "Monto de HIP que recibirá de vuelta",
            "amountOfHIPMoreInfo" : "El HIP reembolsará este monto cada mes que tenga HIP disponible. Obtenga más información en mass.gov/hip.",
            "snapShareErroMsg" : "Elija la Ración de CSA que desea comprar",
            "payWithSNAP": "Pagar con SNAP",
            "payWithSNAPHIP" : "Pagar con SNAP/HIP",
            "share" : "RACIÓN",
            "PickupLocation" : "Lugar/hora de recogida",
            "ChoosePickupLocation" : "Elija un lugar de recogida",
            "PleasechoosePickupLocation" : "Elija un lugar de recogida",
            "DeliveryLocation" : "Lugar de entrega",
            "DeliveryRange" : "intervalo de entrega",
            "AddressLine1" : "Línea 1 para la dirección",
            "AddressLine2" : "Línea 2 para la dirección",
            "City" : "Ciudad",
            "State" : "Estado",
            "Zipcode": "Código postal",
            "CSARights" : "Derechos y responsabilidades de la CSA",
            "IHaveReadTheTerms" : "He leído los términos y condiciones",
            "PleaseCheckTermsError" : "Verifique los términos y condiciones",
            "Date" : "Fecha",
            "ClientSignature" : "Firma del cliente",
            "SignatureErrorMsg" : "La firma del cliente es obligatoria",
            "SubmitApplication" : "Presentar la solicitud",
            "YourCSASignupRequest" : "¡Su formulario de solicitud de inscripción en la CSA ha sido enviado a la granja para su aprobación!",
            "TheFarmAndDTA" : "La granja y el DTA revisarán su solicitud. Una vez que se procese la solicitud, recibirá una notificación.",
            "GoToHomePage" : "Vaya a la página de inicio",
            "AgreementId" : "ID del acuerdo:",
            "ThePaymentScheduleShown" : "El calendario de pagos que se me ha mostrado hasta ahora es estimativo. Mi calendario de pagos y la fecha de inicio de mi CSA podrían cambiar si la granja necesita más tiempo para procesar mi solicitud de CSA.",
            "TheFarmDecidesWhether" : "La granja decide si aprueba mi solicitud de CSA. Si la granja lo aprueba, recibiré una notificación con mi calendario de pagos actual. El aviso me sirve de recibo.",
            "BenefitsWillBe" : "Los beneficios se deducirán automáticamente de mi saldo del SNAP de acuerdo con mi calendario de pagos. Si hay dinero del Programa de Incentivos Saludables (HIP) disponible para mi compra de acciones de CSA, ese monto se sumará automáticamente a mi saldo del SNAP.",
            "MysignupInformation" : "Mi información de inscripción y el estado de mis pagos se compartirán con la granja. La granja puede ponerse en contacto conmigo utilizando la información que he proporcionado en esta solicitud de CSA.",
            "IAmResponsible" : "Soy responsable de recoger mi participación CSA en las fechas y horas determinadas por la granja o de hacer que alguien la recoja por mí. Los lugares, las fechas y los horarios de recogida están sujetos a cambios por parte de la granja. Las participaciones CSA que no se recojan se donarán y no se me reembolsarán. Cualquier acuerdo para la entrega debe hacerse a través de la granja." ,
            "TheType" : "El tipo, el peso y la cantidad de productos variarán semanalmente, y no podré devolver mi participación CSA para obtener un reembolso o un cambio.",
            "IfMySNAP" : "Si el importe de mi beneficio del SNAP disminuye y ya no cubre el costo total de mi participación CSA, es mi responsabilidad informar a la granja. Si decido continuar con la participación CSA, puedo acordar un método de pago alternativo para cubrir la diferencia.",
            "CSAShareDetails" : "Los detalles de la participación CSA y mi experiencia como cliente de CSA son gestionados por la granja. Si tiene preguntas al respecto, puedo ponerme en contacto con la granja. El DTA tiene derecho a cancelar mi participación CSA a solicitud de la granja.",
            "IMayCancel" : "Puedo cancelar mi participación CSA en cualquier momento:",
            "Submitting" : "Presentando una cancelación en DTAFinder.com",
            "Calling" : "llamando a la línea de HIP/CSA al 413-772-3411",
            "CancellationsMust" : "Las cancelaciones deben recibirse antes del día 20 del mes para que sean efectivas para el mes siguiente. De lo contrario, la anulación no podrá producirse hasta el mes siguiente.",
            "IMayBeAsked" : "Es posible que se me pida que complete una breve encuesta sobre el programa piloto CSA del SNAP.",
            "cancelCSAAgreement" : "CANCELAR ACUERDO CSA",
            "signature" : "Firma",
            "cancelSignatureErrMsg" : "Ingrese su firma",
            "noteForCancelCSA" : "Nota: Se cancelarán las raciones seleccionadas en virtud de este acuerdo",
            "description": "Descripción",
            "WeightAmountOfGoods" :"Peso/cantidad de productos",
            "PickupDayTime" : "Día/hora de recogida",
            "validDayError":"Ingrese un día válido entre 1 y 31 ",
            "validYearError": "Ingrese un año válido",
            "PickA": "Seleccione una",
            "shareBelow" : "ración a continuación. Esta página muestra cuánto SNAP y",
            "youGetEachMonth" : "recibe cada mes que podría utilizarse para un pago mensual de SNAP CSA.",
            "IfYouNeedHelp": "Si necesita ayuda, puede pedirnos que le llamemos para continuar con la solicitud de CSA por teléfono.",
            "ThisPaymentSchedule": "Este calendario de pagos es estimativo y se basa en la fecha de hoy. La fecha de inicio de CSA y el calendario de pagos podrían ocurrir más adelante si la granja necesita más tiempo para procesar su solicitud de CSA.",
            "SelectPickupTime":"Seleccione una hora de recogida",
            "Your":"Su",
            "YouMay":"Si lo desea, puede",
            "download":"descargar su acuerdo",
            "reference":"para consultarlo en el futuro.",

        }
    }else if(language === "pt-BR") {
        return {
            "landingImgTxt" : "Os programas da Community Supported Agriculture (CSA) oferecem aos clientes SNAP acesso a frutas e vegetais frescos e nutritivos, apoiando os produtores locais. O DTA trabalha com produtores locais para oferecer aos clientes SNAP uma via simples de pagamento de frutas e vegetais – automaticamente da conta SNAP, todos os meses –, a partir do dia em que são creditados os benefícios. Para obter informações sobre como se inscrever em um CSA, clique no botão Saiba mais abaixo.",
            "EnrollCSA" : "Inscreva-se em uma cota CSA",
            "CancelCSA" : "Cancele a sua cota CSA",
            "learnMore" : "Saiba mais",
            "farmInfo" : "Informações do produtor",
            "clientInfo" : "Informações do cliente",
            "snapCSA" : "Cota CSA SNAP",
            "pickupDelivery": "Local de coleta/entrega",
            "signAndSubmit" : "Assinar e enviar",
            "chooseFarm" : "Escolha o produtor",
            "select" : "Selecionar",
            "Notes about our CSA": "Observações sobre o nosso CSA",
            "Website" : "Site",
            "Next" : "Próximo",
            "Prev" : "Ant",
            "firstName" : "Nome (como está no seu caso SNAP)",
            "lastName": "Sobrenome (como está no seu caso SNAP)",
            "chosenName": "Nome preferido/Como quer ser chamado",
            "dateOfBirth": "Data de nascimento",
            "month": "Mês",
            "day": "Dia",
            "year" : "Ano",
            "ebtCardAgencyId": "Número do cartão EBT / ID da Agência DTA",
            "email": "E-mail",
            "phone" : "Telefone (com código de área)",
            "cancelShareAgreement" : "CANCELAMENTO DA COTA CSA - ACORDO",
            "sorryToGo" : "É uma pena que você esteja indo embora",
            "pleaseProvide" : "Para cancelar a sua cota CSA, forneça as informações a seguir",
            "cancelFirstName": "Nome",
            "cancelLastName" : "Sobrenome",
            "ebtCard": "Número do cartão EBT",
            "agencyId" : "ID da Agência DTA",
            "submit" : "Enviar",
            "anyQuestions" : "Em caso de dúvidas, fale diretamente com o produtor.",
            "cancelError": " obrigatório",
            "cancelFirstNameError": "Nome obrigatório",
            "cancelLastNameError": "Sobrenome obrigatório",
            "cancelMonthError": "Mês obrigatório",
            "cancelDateError": "Data obrigatória",
            "cancelYearError": "Ano obrigatório",
            "cancelEbtCardAgencyIdError": "Número do cartão EBT / ID da Agência DTA obrigatórios",
            "cancelEbtCardError": "Número do cartão EBT obrigatórios",
            "cancelAgencyIdError": "ID da Agência DTA obrigatórios",
            "details": "Informações",
            "vendorName": "Nome do fornecedor ",
            "agreementStatus" : "Status do acordo",
            "shareName" : "Nome da cota",
            "expiresOn" : "Expira em",
            "amount" : "Valor",
            "cancel" : "Cancelar",
            "monthly" : "Mensal",
            "daily" : "Diariamente",
            "January": "Janeiro",
            "February": "Fevereiro",
            "March" : "Março",
            "April" : "Abril",
            "May" : "Maio",
            "June" : "Junho",
            "July" : "Julho",
            "August" : "Agosto",
            "September" : "Setembro",
            "October" : "Outubro",
            "November" : "Novembro",
            "December" : "Dezembro",
            "Change in Benefit Amount" : "Mudanças no valor do benefício",
            "Change share type" : "Mudanças no tipo de cota",
            "Cancelled due to HIP Suspension" : "Cancelado devido à suspensão do HIP ",
            "No reason given": "Nenhum motivo informado",
            "Transportation/Medical Issues": "Questões médicas/de transporte",
            "Unsatisfied with share" : "Insatisfação com a cota",
            "Other Reason" : "Outro motivo",
            "Reason for cancellation": "Motivo do cancelamento",
            "pleaseChooseTheReason" : "Informe o motivo",
            "farmError" : "Selecione um produtor para prosseguir",
            "signupDateOfBirthError" : "Digite a data de nascimento",
            "signupFirstNameError" : "Digite o nome",
            "signupLastNameError" : "Digite o sobrenome",
            "signupAgencyIdError" : "Digite o ID da agência DTA",
            "signupEBTCardError" : "Digite o número do cartão EBT",
            "signupPhoneError" : "Digite o telefone principal" ,
            "csaSignup" : "REGISTRO DO CSA",
            "preferNameMoreInfo" : "Nome pelo qual você quer ser chamado pelo fornecedor (pode ser o mesmo nome ou um diferente daquele que está no seu caso SNAP).",
            "contactInfoMoreInfo" : "As informações de contato que você fornecer aqui serão compartilhadas com o produtor do CSA para que ele se comunique com você sobre a sua solicitação de registro no CSA. O DTA não irá usar essas informações para atualizar a sua conta DTA principal. Para atualizar a sua conta DTA principal, acesse ",
            "howToUseThisPage" : "Como usar esta página",
            "snapCSAWorks" : "Veja como funciona o CSA SNAP",
            "snapCSAComboBox" : "O programa piloto do CSA SNAP permite que você se registre em uma assinatura mensal junto a um produtor local usando os seus benefícios SNAP. O produtor é quem decide quais frutas e/ou vegetais serão fornecidos e com que frequência. A ‘cota CSA’ se refere à quantidade de vegetais que você recebe. O pagamento é feito automaticamente pelo SNAP a cada mês, com base na cota CSA escolhida. ‘SNAP’ significa ‘Supplemental Nutrition Assistance Program’ (ou ‘Programa de Assistência Nutricional Suplementar’). ‘CSA’ significa ‘Community Supported Agriculture’ (ou ‘Agricultura Apoiada pela Comunidade’).",
            "hipComboBox" : "Caso você veja um valor HIP abaixo, isso significa que o produtor que você escolheu participa do programa HIP. ‘HIP’ significa ‘Healthy Incentives Program’ (ou ‘Programa de Incentivos à Saúde’). O HIP devolverá a você um crédito SNAP, até o valor HIP exibido abaixo, sempre que você fizer um pagamento mensal do CSA SNAP. Para saber mais sobre o HIP, acesse",
            "EstimatedComboBox": "As datas de pagamento e o mês de início do CSA são calculados usando a data atual. Caso o produtor precise de mais tempo para processar a sua solicitação, essas datas podem mudar.",
            "RequestHelpPopup" : "Já coletamos as informações que você digitou até agora. Em alguns casos, você não conseguirá finalizar a solicitação do CSA pela internet. Escolha ‘sim’ caso você precise de ajuda do DTA. Entraremos em contato com você nos próximos dias úteis. Escolha ‘não’ para retornar ao formulário.",
            "SnapCSAButton" : "CSA SNAP",
            "HIPButton" : "HIP",
            "EstimatedButton" : "Estimado",
            "RequestButton" : "Solicitação de ajuda",
            "Yes" : "Sim",
            "No" : "Não", 
            "IfTheFarmSays" : "Caso o produtor aceite a sua solicitação do CSA, o DTA irá enviar a você uma Notificação de Aprovação do CSA SNAP contendo as datas de pagamento. Os pagamentos do CSA SNAP começam antes de você receber a sua cota CSA. As datas de pagamento exibidas abaixo para cada cota CSA são ",   
            "YourSnapMonthlyAmount": "O seu valor mensal SNAP",
            "YourHIPMontlhyCap" : "O seu valor mensal HIP",
            "PleaseCheckOff" : "Marque a opção do CSA desejada",
            "ShareDetails" : "Informações da cota",
            "CSAStartMonth" :"CSA - Mês inicial: ",
            "CSAEndMonth" :"CSA - Mês final: ",
            "MonthlyShareCost" : " Custo mensal da cota: ",
            "YourCSAPaymentSchedule" : "Cronograma de pagamento do CSA",
            "PaymentDate" : "Data do pagamento",
            "PaymentAmount" : "Valor do pagamento",
            "overAllCost" : "Custo total",
            "upcomingMonthlyCSA" : "Pagamento total do CSA referente ao mês seguinte",
            "amountOfHIP" : "Valor HIP que você receberá de volta",
            "amountOfHIPMoreInfo" : "O HIP irá reembolsar este valor a cada mês. Para saber mais, acesse mass.gov/hip.",
            "snapShareErroMsg" : "Escolha a cota CSA desejada",
            "payWithSNAP": "Pagar com SNAP",
            "payWithSNAPHIP" : "Pagar com SNAP/HIP",
            "share" : "COTA",
            "PickupLocation" : "Local de coleta",
            "ChoosePickupLocation" : "Escolha um local de coleta",
            "PleasechoosePickupLocation" : "Escolha um local de coleta",
            "DeliveryLocation" : "Local de entrega",
            "DeliveryRange" : "área de entrega",
            "AddressLine1" : "Endereço (Linha 1)",
            "AddressLine2" : "Endereço (Linha 2)",
            "City" : "Cidade",
            "State" : "Estado",
            "Zipcode": "Zip Code",
            "CSARights" : "Direitos e Responsabilidades do CSA",
            "IHaveReadTheTerms" : "Li os Termos e Condições",
            "PleaseCheckTermsError" : "Marque a caixa de Termos e Condições",
            "Date" : "Data",
            "ClientSignature" : "Assinatura do cliente",
            "SignatureErrorMsg" : "Assinatura do cliente obrigatória",
            "SubmitApplication" : "Enviar solicitação",
            "YourCSASignupRequest" : "O seu formulário de solicitação de registro do CSA foi enviado para a aprovação do produtor!",
            "TheFarmAndDTA" : "O produtor e o DTA irão analisar a sua solicitação. Assim que a solicitação for processada, você receberá uma notificação.",
            "GoToHomePage" : "Ir à página inicial",
            "AgreementId" : "ID do acordo:",
            "ThePaymentScheduleShown" : "O cronograma de pagamento que me foi apresentado até o momento é estimado. Meu cronograma de pagamento e a data de início do CSA podem mudar se a fazenda precisar de mais tempo para processar minha solicitação de CSA.",
            "TheFarmDecidesWhether" : "A fazenda decide se aprova ou não minha solicitação de CSA. Se a fazenda aprovar, receberei um aviso que mostrará meu cronograma de pagamento real. O aviso serve como recibo.",
            "BenefitsWillBe" : "Os benefícios serão automaticamente deduzidos de meu saldo SNAP de acordo com meu cronograma de pagamento. Se o dinheiro do Healthy Incentives Program (HIP) estiver disponível para a compra de minha cota no CSA, esse valor será automaticamente adicionado ao meu saldo SNAP.",
            "MysignupInformation" : "Minhas informações de inscrição e o status dos meus pagamentos serão compartilhados com a fazenda. A fazenda poderá entrar em contato comigo usando as informações que forneci nesta solicitação de CSA.",
            "IAmResponsible" : "Sou responsável por retirar minha cota do CSA nas datas e horários determinados pela fazenda ou por pedir a alguém que a retire para mim. Os locais, datas e horários de retirada estão sujeitos a alterações pela fazenda. As cotas do CSA que não forem retiradas serão doadas e eu não receberei reembolso. Todas as providências para entrega devem ser tomadas por meio da fazenda." ,
            "TheType" : "O tipo, o peso e a quantidade de produtos variam semanalmente, e não posso devolver minha cota do CSA para reembolso ou troca.",
            "IfMySNAP" : "Sou responsável por informar a fazenda se o valor do meu benefício SNAP diminuir e não cobrir mais o custo total da cota do CSA. Se eu optar por continuar com a cota no CSA, posso providenciar um método de pagamento alternativo para cobrir a diferença.",
            "CSAShareDetails" : "Os detalhes da cota do CSA e minha experiência como cliente do CSA são gerenciados pela fazenda. Se tiver dúvidas sobre isso, devo entrar em contato com a fazenda. A DTA tem o direito de cancelar minha cota no CSA mediante solicitação da fazenda.",
            "IMayCancel" : "Posso cancelar minha cota no CSA a qualquer momento:",
            "Submitting" : "enviando uma solicitação de cancelamento no DTAFinder.com",
            "Calling" : "ligando para a Central de Atendimento do HIP/CSA no número 413-772-3411",
            "CancellationsMust" : "As solicitações de cancelamento devem ser recebidas até o dia 20 do mês atual para entrar em vigor no mês seguinte. Caso contrário, o cancelamento só poderá ocorrer no mês seguinte.",
            "IMayBeAsked" : "Poderei ser solicitado a responder a uma breve pesquisa sobre o piloto do SNAP CSA.",
            "cancelCSAAgreement" : "ACORDO DE CANCELAMENTO DO CSA",
            "signature" : "Assinatura",
            "cancelSignatureErrMsg" : "Insira sua assinatura",
            "noteForCancelCSA" : "Nota: As cotas selecionadas neste acordo serão canceladas",
            "description": "Descrição",
            "WeightAmountOfGoods" :"Peso/quantidade de produtos",
            "PickupDayTime" : "Dia/horário da coleta",
            "validDayError":"Insira um dia válido entre 1 e 31 ",
            "validYearError": "Digite um ano válido",
            "PickA": "Selecione uma",
            "shareBelow" : "cota abaixo. Esta página mostra quanto você recebe de SNAP",
            "youGetEachMonth" : "a cada mês. Esse valor pode ser usado para o pagamento mensal do CSA SNAP.",
            "IfYouNeedHelp": "Se precisar de ajuda, solicite que alguém da nossa equipe ligue para você para continuar a solicitação do CSA por telefone.",
            "ThisPaymentSchedule": "Esse cronograma de pagamento é estimado com base na data de hoje. A data de início do CSA e o cronograma de pagamento podem ser adiados se a fazenda precisar de mais tempo para processar sua solicitação do CSA.",
            "SelectPickupTime":"Selecione um horário de coleta",
            "Your":"Seu",
            "YouMay":"Se desejar,",
            "download":"baixe seu acordo",
            "reference":" para referência futura.",

        }
    }else if(language === "zh-Hans") {
        return {
            "landingImgTxt" : "社区支持农业 (CSA) 计划致力于为 SNAP 用户提供营养丰富的新鲜果蔬，同时扶持当地农民。过渡援助部 (DTA) 与当地农民携手合作，共同为 SNAP 用户提供便利，使其能够在每月领取补助金当天自动使用 SNAP 帐户支付果蔬费用. 有关如何注册 CSA 的信息，请按下方的“了解更多”按钮。",
            "EnrollCSA" : "注册 CSA 份额",
            "CancelCSA" : "取消 CSA 份额",
            "learnMore" : "了解详情",
            "farmInfo" : "农场信息",
            "clientInfo" : "客户信息",
            "snapCSA" : "SNAP CSA 份额",
            "pickupDelivery": "取货/送货地点",
            "signAndSubmit" : "签名并提交",
            "chooseFarm" : "选择农场",
            "select" : "选择",
            "Notes about our CSA": "CSA 注意事项",
            "Website" : "网站",
            "Next" : "下一页",
            "Prev" : "上一页",
            "firstName" : "名字（与 SNAP 案例中的名字一致）",
            "lastName": "姓氏（与 SNAP 案例中的姓氏一致）",
            "chosenName": "首选/选择的名字",
            "dateOfBirth": "出生日期",
            "month": "月",
            "day": "日",
            "year" : "年",
            "ebtCardAgencyId": "EBT 卡号/DTA 机构 ID",
            "email": "电子邮件",
            "phone" : "电话（包括区号）",
            "cancelShareAgreement" : "取消 CSA 份额协议",
            "sorryToGo" : "我们对您的离去感到遗憾",
            "pleaseProvide" : "请提供以下信息以取消您的 CSA 协议",
            "cancelFirstName": "名字",
            "cancelLastName" : "姓氏",
            "ebtCard": "EBT 卡号",
            "agencyId" : "DTA 机构 ID",
            "submit" : "提交",
            "anyQuestions" : "如有任何疑问，请直接联系农场。",
            "cancelError": " 为必填项",
            "cancelFirstNameError": "名字为必填项",
            "cancelLastNameError": "姓氏为必填项",
            "cancelMonthError": "月份为必填项",
            "cancelDateError": "日期为必填项",
            "cancelYearError": "年份为必填项",
            "cancelEbtCardAgencyIdError": "EBT 卡号/DTA 机构 ID 为必填项",
            "cancelEbtCardError": "EBT 卡号 为必填项",
            "cancelAgencyIdError": "DTA 机构 ID 为必填项",
            "details": "详情",
            "vendorName": "供应商名称",
            "agreementStatus" : "协议状态",
            "shareName" : "份额名称",
            "expiresOn" : "到期日期",
            "amount" : "数量",
            "cancel" : "取消",
            "monthly" : "每月一次",
            "daily" : "每天",
            "January": "1 月",
            "February": "2 月",
            "March" : "3 月",
            "April" : "4 月",
            "May" : "5 月",
            "June" : "6 月",
            "July" : "7 月",
            "August" : "8 月",
            "September" : "9 月",
            "October" : "10 月",
            "November" : "11 月",
            "December" : "12 月",
            "Change in Benefit Amount" : "补助金额变更",
            "Change share type" : "更改份额类型 ",
            "Cancelled due to HIP Suspension" : "由于 HIP 暂停而取消",
            "No reason given": "未说明原因",
            "Transportation/Medical Issues": "交通/医疗问题",
            "Unsatisfied with share" : "对份额不满意",
            "Other Reason" : "其他原因",
            "Reason for cancellation": "取消原因",
            "pleaseChooseTheReason" : "请选择原因",
            "farmError" : "请选择农场以继续",
            "signupDateOfBirthError" : "请输入出生日期",
            "signupFirstNameError" : "请输入名字",
            "signupLastNameError" : "请输入姓氏",
            "signupAgencyIdError" : "请输入 DTA 机构 ID",
            "signupEBTCardError" : "请输入 EBT 卡号",
            "signupPhoneError" : "请输入常用电话号码" ,
            "csaSignup" : "CSA 注册",
            "preferNameMoreInfo" : "您希望供应商用来称呼您的姓名可能与 SNAP 案例中的名字相同或不同",
            "contactInfoMoreInfo" : "您在此处提供的联系信息将与 CSA 农场共享，以便农场与您沟通 CSA 注册申请事宜。DTA 不会使用此信息来更新您的 DTA 主帐户。要更新您的 DTA 主帐户，请登录 ",
            "howToUseThisPage" : "如何使用此页面",
            "snapCSAWorks" : "了解 SNAP CSA 的运作方式",
            "snapCSAComboBox" : "SNAP CSA 试点计划让您可以使用 SNAP 补助金按月订购当地农场的产品。要提供的水果和/或蔬菜种类以及提供频率由农场决定。您获得的农产品称为 CSA 份额。您每月根据所选的 CSA 份额自动使用 SNAP 付款。SNAP 表示补充营养援助计划。CSA 表示社区支持农业计划。",
            "hipComboBox" : "如果您看到下面有 HIP 金额，则表示您选择的农场参加了 HIP 计划。HIP 表示健康激励计划。您每次完成 SNAP CSA 月付款后，HIP 会将 SNAP 补助金退还给您 SNAP，退还金额最高可达下方显示的 HIP 金额。如需详细了解 HIP，请访问",
            "EstimatedComboBox": "CSA 付款日期和起始月份是根据今天的日期计算得出的。如果农场需要更多时间处理您的 CSA 申请，这两个日期都可能有所变化。",
            "RequestHelpPopup" : "我们已获取您到目前为止输入的信息。在某些情况下，您无法在线完成 CSA 申请。选择“是”向 DTA 寻求帮助，我们将在未来几个工作日内与您联系。选择“否”返回表单",
            "SnapCSAButton" : "SNAP CSA",
            "HIPButton" : "HIP",
            "EstimatedButton" : "估计",
            "RequestButton" : "请求帮助",
            "Yes" : "是",
            "No" : "否",   
            "IfTheFarmSays" : "如果农场同意您的 CSA 申请，DTA 将向您发送 SNAP CSA 批准通知，其中包含您的实际付款日期。SNAP CSA 付款在您开始收到 CSA 份额之前开始。下面显示的每个 CSA 份额的付款日期是", 
            "YourSnapMonthlyAmount": "您的 SNAP 每月金额",
            "YourHIPMontlhyCap" : "您的 HIP 每月限额",
            "PleaseCheckOff" : "请勾选您想要购买的 CSA 选项",
            "ShareDetails" : "份额详情",
            "CSAStartMonth" :"CSA 起始月份：",
            "CSAEndMonth" :"CSA 截止月份：",
            "MonthlyShareCost" : " 每月份额费用：",
            "YourCSAPaymentSchedule" : "您的 CSA 付款时间表",
            "PaymentDate" : "付款日期",
            "PaymentAmount" : "付款金额",
            "overAllCost" : "总费用",
            "upcomingMonthlyCSA" : "即将支付的 CSA 月付款总额",
            "amountOfHIP" : "要退还给您的 HIP 金额",
            "amountOfHIPMoreInfo" : "只要您可以使用 HIP，HIP 就会每月报销这笔金额。如需了解详情，请访问 mass.gov/hip。",
            "snapShareErroMsg" : "请选择您想要购买的 CSA 份额",
            "payWithSNAP": "使用 SNAP 付款",
            "payWithSNAPHIP" : "使用 SNAP/HIP 付款",
            "share" : "份额",
            "PickupLocation" : "取货地点",
            "ChoosePickupLocation" : "选择取货地点",
            "PleasechoosePickupLocation" : "请选择取货地点",
            "DeliveryLocation" : "送货地点",
            "DeliveryRange" : "送货范围",
            "AddressLine1" : "地址第 1 行",
            "AddressLine2" : "地址第 2 行",
            "City" : "城市",
            "State" : "州",
            "Zipcode": "邮政编码",
            "CSARights" : "CSA 权利与责任",
            "IHaveReadTheTerms" : "我已阅读条款和条件",
            "PleaseCheckTermsError" : "请查看条款和条件",
            "Date" : "日期",
            "ClientSignature" : "客户签名",
            "SignatureErrorMsg" : "需要客户签名",
            "SubmitApplication" : "提交申请",
            "YourCSASignupRequest" : "您的 CSA 注册申请表已提交给农场审批！",
            "TheFarmAndDTA" : "农场和 DTA 将审核您的申请。申请处理完毕后，您将收到通知。",
            "GoToHomePage" : "转到首页",
            "AgreementId" : "协议 ID：",
            "ThePaymentScheduleShown" : "目前为止我看到的付款时间表是预估的。如果农场需要更多时间处理我的 CSA 申请，我的付款时间表和 CSA 开始日期可能有所变化。",
            "TheFarmDecidesWhether" : "农场决定是否批准我的 CSA 申请。如果农场批准，我将收到一份提供实际付款时间表的通知。这份通知便是我的收据。",
            "BenefitsWillBe" : "补助金将按照付款时间表自动从我的 SNAP 余额中扣除。如果健康激励计划 (HIP) 资金可用于购买 CSA 分享，相应金额将自动转回我的 SNAP 余额。",
            "MysignupInformation" : "我的注册信息和付款状态会与农场共享。农场可以使用我在此 CSA 申请中提供的信息联系我。",
            "IAmResponsible" : "我负责在农场确定的日期和时间自行领取或让他人帮我领取我的 CSA 分享。农场可能会更改取货地点、日期和时间。未领取的 CSA 分享将会捐出，款项不会退还给我。所有送货事宜必须通过农场安排。" ,
            "TheType" : "产品的类型、重量和数量每周有所不同，我不能退回我的 CSA 分享并要求退款或更换。",
            "IfMySNAP" : "如果我的 SNAP 补助金额减少且不足以支付 CSA 分享的全部费用，我应负责通知农场。如果我选择继续使用 CSA 分享，我可以采用其他付款方式弥补差额。",
            "CSAShareDetails" : "CSA 分享详情和我的 CSA 客户体验由农场负责管理。如果对此有疑问，我可以联系农场。DTA 有权应农场要求取消我的 CSA 分享。",
            "IMayCancel" : "我可以通过以下方式随时取消 CSA 分享：",
            "Submitting" : "在 DTAFinder.com 上提交取消申请",
            "Calling" : "致电 HIP/CSA 热线 413-772-3411",
            "CancellationsMust" : "当月 20 日之前成功提交取消，方可在次月生效。否则，取消可能延续至下个月生效。",
            "IMayBeAsked" : "我可能需要填写一份有关 SNAP CSA 试点计划的简短调查。",
            "cancelCSAAgreement" : "取消 CSA 协议",
            "signature" : "签名",
            "cancelSignatureErrMsg" : "请输入您的签名",
            "noteForCancelCSA" : "注意：本协议项下的选定股份将被取消",
            "description": "说明",
            "WeightAmountOfGoods" :"货物重量/数量",
            "PickupDayTime" : "取货日期/时间",
            "validDayError":"请输入有效的日期，范围为 1 至 31 ",
            "validYearError": "请输入有效的年份",
            "PickA": "选择",
            "shareBelow" : "下面的份额。此页面所示为",
            "youGetEachMonth" : "您每月可用于 SNAP CSA 月付款的 SNAP 和 金额。",
            "IfYouNeedHelp": "如需帮助，您可以要求我们来电继续办理 CSA 申请。",
            "ThisPaymentSchedule": "此付款时间表根据今日日期估算得出。如果农场需要更多时间处理您的 CSA 申请，CSA 开始日期和付款时间表可能会推迟。",
            "SelectPickupTime":"选择取货时间",
            "Your":"您的",
            "YouMay":"您不妨 ",
            "download":"下载您的协议，",
            "reference":" 以备将来查看。",

        }
    }else if(language === "vi-VI") {
        return {
            "landingImgTxt" : "Các chương trình Nông nghiệp do cộng đồng hỗ trợ (CSA) cung cấp cho khách hàng SNAP các loại trái cây và rau quả tươi, bổ dưỡng đồng thời hỗ trợ nông dân địa phương. DTA hợp tác với nông dân địa phương để cung cấp cho khách hàng SNAP một cách dễ dàng để thanh toán trái cây và rau quả tự động từ tài khoản SNAP của bạn mỗi tháng vào ngày bạn nhận được trợ cấp. Để biết thông tin về cách đăng ký CSA, hãy nhấn vào nút Tìm hiểu thêm bên dưới.",
            "EnrollCSA" : "Đăng ký tham gia Cổ phần CSA",
            "CancelCSA" : "Hủy Cổ phần CSA của bạn",
            "learnMore" : "Tìm hiểu thêm",
            "farmInfo" : "Thông tin trang trại",
            "clientInfo" : "Thông tin khách hàng",
            "snapCSA" : "Cổ phần SNAP CSA",
            "pickupDelivery": "Địa điểm nhận/giao hàng",
            "signAndSubmit" : "Ký và gửi",
            "chooseFarm" : "Chọn trang trại",
            "select" : "Chọn",
            "Notes about our CSA": "Ghi chú về CSA của chúng tôi",
            "Website" : "Trang web",
            "Next" : "Tiếp theo",
            "Prev" : "Trước",
            "firstName" : "Tên (như được ghi trong trường hợp SNAP của bạn)",
            "lastName": "Họ (như được ghi trong trường hợp SNAP của bạn)",
            "chosenName": "Tên ưa thích/được chọn",
            "dateOfBirth": "Ngày sinh",
            "month": "Tháng",
            "day": "Ngày",
            "year" : "Năm",
            "ebtCardAgencyId": "Số thẻ EBT / Mã số cơ quan DTA",
            "email": "Email",
            "phone" : "Điện thoại (bao gồm mã vùng)",

            "cancelShareAgreement" : "HỦY THỎA THUẬN CỔ PHẦN CSA",
            "sorryToGo" : "Chúng tôi rất tiếc khi thấy bạn ra đi",
            "pleaseProvide" : "Vui lòng cung cấp thông tin sau để hủy thỏa thuận CSA của bạn",
            "cancelFirstName": "Tên",
            "cancelLastName" : "Họ",
            "ebtCard": "Số thẻ EBT",
            "agencyId" : "Mã số cơ quan DTA",
            "submit" : "Gửi",
            "anyQuestions" : "Nếu bạn có bất kỳ câu hỏi nào, vui lòng liên hệ trực tiếp với trang trại.",
            "cancelError": " là bắt buộc",
            "cancelFirstNameError": "Tên là bắt buộc",
            "cancelLastNameError": "Họ là bắt buộc",
            "cancelMonthError": "Tháng là bắt buộc",
            "cancelDateError": "Ngày là bắt buộc",
            "cancelYearError": "Năm là bắt buộc",
            "cancelEbtCardAgencyIdError": "Số thẻ EBT / Mã số cơ quan DTA là bắt buộc",
            "cancelEbtCardError": "Số thẻ EBT là bắt buộc",
            "cancelAgencyIdError": "Mã số cơ quan DTA là bắt buộc",
            "details": "Chi tiết",
            "vendorName": "Tên nhà cung cấp",
            "agreementStatus" : "Tình trạng Thỏa thuận",
            "shareName" : "Tên cổ phần",
            "expiresOn" : "Hết hạn vào",
            "amount" : "Số tiền",
            "cancel" : "Hủy",
            "monthly" : "Hàng tháng",
            "daily" : "Mỗi ngày",
            "January": "Tháng 1",
            "February": "Tháng 2",
            "March" : "Tháng 3",
            "April" : "Tháng 4",
            "May" : "Tháng 5",
            "June" : "Tháng 6",
            "July" : "Tháng 7",
            "August" : "Tháng 8",
            "September" : "Tháng 9",
            "October" : "Tháng 10",
            "November" : "Tháng 11",
            "December" : "Tháng 12",
            "Change in Benefit Amount" : "Thay đổi số tiền lãi",
            "Change share type" : "Thay đổi loại cổ phần",
            "Cancelled due to HIP Suspension" : "Hủy do đình chỉ HIP",
            "No reason given": "Không đưa ra lý do",
            "Transportation/Medical Issues": "Vấn đề về vận chuyển/y tế",
            "Unsatisfied with share" : "Không hài lòng với cổ phần",
            "Other Reason" : "Lý do khác",
            "Reason for cancellation": "Lý do hủy",
            "pleaseChooseTheReason" : "Vui lòng chọn lý do",
            "farmError" : "Vui lòng chọn một trang trại để tiếp tục",
            "signupDateOfBirthError" : "Vui lòng nhập Ngày sinh",
            "signupFirstNameError" : "Vui lòng nhập Tên",
            "signupLastNameError" : "Vui lòng nhập Họ",
            "signupAgencyIdError" : "Vui lòng nhập Mã số Cơ quan DTA",
            "signupEBTCardError" : "Vui lòng nhập Số thẻ EBT",
            "signupPhoneError" : "Vui lòng nhập Số điện thoại chính" ,
            "csaSignup" : "ĐĂNG KÝ CSA",
            "preferNameMoreInfo" : "Tên bạn muốn nhà cung cấp gọi bạn có thể giống hoặc khác với tên trên trường hợp SNAP",
            "contactInfoMoreInfo" : "Thông tin liên lạc bạn cung cấp ở đây sẽ được chia sẻ với nông trại CSA để nông trại liên lạc với bạn về yêu cầu đăng ký CSA của bạn. DTA sẽ không sử dụng thông tin này để cập nhật tài khoản DTA chính của bạn. Để cập nhật tài khoản DTA chính của bạn, vui lòng đăng nhập vào ",
            "howToUseThisPage" : "Cách sử dụng trang này",
            "snapCSAWorks" : "Xem cách thức hoạt động của SNAP CSA",
            "snapCSAComboBox" : "SNAP CSA Pilot cho phép bạn đăng ký thuê bao hàng tháng tại một trang trại địa phương bằng các quyền lợi SNAP của bạn. Trang trại quyết định loại trái cây và/hoặc rau quả nào sẽ cung cấp và tần suất như thế nào. Sản phẩm bạn nhận được được gọi là phần chia CSA. Bạn tự động thanh toán bằng SNAP hàng tháng dựa trên phần chia CSA mà bạn chọn. SNAP là viết tắt của Chương trình hỗ trợ dinh dưỡng bổ sung. CSA là viết tắt của Nông nghiệp được cộng đồng hỗ trợ.",
            "hipComboBox" : "Nếu bạn thấy số tiền HIP bên dưới, trang trại bạn chọn có tham gia HIP. HIP là viết tắt của Chương trình khuyến khích lành mạnh. HIP sẽ trả lại SNAP cho bạn, lên đến số tiền HIP được hiển thị bên dưới, khi bạn thực hiện mỗi khoản thanh toán SNAP CSA hàng tháng. Để tìm hiểu thêm về HIP, hãy truy cập",
            "EstimatedComboBox": "Ngày thanh toán CSA và tháng bắt đầu được tính bằng ngày hôm nay. Cả hai đều có thể thay đổi nếu trang trại cần thêm thời gian để xử lý yêu cầu của bạn.",
            "RequestHelpPopup" : 'Chúng tôi đã ghi lại thông tin bạn đã nhập cho đến thời điểm này. Trong một số trường hợp, bạn sẽ không thể hoàn tất yêu cầu CSA này trực tuyến. Chọn "có" để được DTA trợ giúp và chúng tôi sẽ liên hệ với bạn trong vài ngày làm việc tiếp theo. Chọn "không" để quay lại biểu mẫu',
            "SnapCSAButton" : "SNAP CSA",
            "HIPButton" : "HIP",
            "EstimatedButton" : "Ước tính",
            "RequestButton" : "Yêu cầu trợ giúp",
            "Yes" : "Có",
            "No" : "Không",
            "IfTheFarmSays" : "Nếu trang trại trả lời đồng ý với yêu cầu CSA của bạn, DTA sẽ gửi cho bạn Thông báo chấp thuận SNAP CSA với ngày thanh toán thực tế của bạn. Các khoản thanh toán SNAP CSA sẽ bắt đầu trước khi bạn bắt đầu nhận được phần chia CSA của mình. Các ngày thanh toán được hiển thị bên dưới cho mỗi phần chia CSA là",   
            "YourSnapMonthlyAmount": "Số tiền SNAP hàng tháng của bạn",
            "YourHIPMontlhyCap" : "Mức trần HIP hàng tháng của bạn",
            "PleaseCheckOff" : "Vui lòng đánh dấu vào tùy chọn CSA mà bạn muốn mua",
            "ShareDetails" : "Chi tiết chia sẻ",
            "CSAStartMonth" : "Tháng bắt đầu CSA: ",
            "CSAEndMonth" : "Tháng kết thúc CSA: ",
            "MonthlyShareCost" : " Chi phí chia sẻ hàng tháng: ",
            "YourCSAPaymentSchedule" : "Lịch trình thanh toán CSA của bạn",
            "PaymentDate" : "Ngày thanh toán",
            "PaymentAmount" : "Số tiền thanh toán",
            "overAllCost" : "Tổng chi phí",
            "upcomingMonthlyCSA" : "Tổng số tiền thanh toán CSA hàng tháng sắp tới",
            "amountOfHIP" : "Số tiền HIP bạn sẽ nhận lại",
            "amountOfHIPMoreInfo" : "HIP sẽ hoàn trả số tiền này mỗi tháng khi bạn có HIP. Tìm hiểu thêm tại mass.gov/hip.",
            "snapShareErroMsg" : "Vui lòng chọn Phần CSA mà bạn muốn mua",
            "payWithSNAP": "Thanh toán bằng SNAP",
            "payWithSNAPHIP" : "Thanh toán bằng SNAP/HIP",
            "share" : "SHARE",
            "PickupLocation" : "Địa điểm nhận hàng",
            "ChoosePickupLocation" : "Chọn Địa điểm nhận hàng",
            "PleasechoosePickupLocation" : "Vui lòng chọn địa điểm nhận hàng",
            "DeliveryLocation" : "Địa điểm giao hàng ",
            "DeliveryRange" : "Phạm vi giao hàng",
            "AddressLine1" : "Dòng địa chỉ 1",
            "AddressLine2" : "Dòng địa chỉ 2",
            "City" : "Thành phố",
            "State" : "Tiểu bang",
            "Zipcode": "Mã bưu chính",
            "CSARights" : "Quyền và trách nhiệm của CSA",
            "IHaveReadTheTerms" : "Tôi đã đọc các điều khoản và điều kiện",
            "PleaseCheckTermsError" : "Vui lòng kiểm tra các điều khoản và điều kiện",
            "Date" : "Ngày",
            "ClientSignature" : "Chữ ký của khách hàng",
            "SignatureErrorMsg" : "Yêu cầu chữ ký của khách hàng",
            "SubmitApplication" : "Gửi đơn đăng ký",
            "YourCSASignupRequest" : "Mẫu yêu cầu đăng ký CSA của bạn đã được gửi đến trang trại để phê duyệt!",
            "TheFarmAndDTA" : "Trang trại và DTA sẽ xem xét yêu cầu của bạn. Sau khi yêu cầu được xử lý, bạn sẽ nhận được thông báo.",
            "GoToHomePage" : "Đến Trang chủ",
            "AgreementId" : "Id Thỏa Thuận :",
            "ThePaymentScheduleShown" : "Lịch thanh toán hiển thị cho tôi cho đến nay là ước tính. Lịch thanh toán và ngày bắt đầu CSA của tôi có thể thay đổi nếu trang trại cần thêm thời gian để xử lý yêu cầu CSA của tôi.",
            "TheFarmDecidesWhether" : "Trang trại quyết định có chấp thuận yêu cầu CSA của tôi hay không. Nếu trang trại chấp thuận, tôi sẽ nhận được thông báo cho biết lịch thanh toán thực tế của tôi. Thông báo đóng vai trò là biên nhận của tôi.",
            "BenefitsWillBe" : "Các phúc lợi sẽ tự động được khấu trừ từ số dư SNAP của tôi theo lịch trình thanh toán của tôi. Nếu tiền của Chương Trình Khuyến Khích Lành Mạnh (HIP) có sẵn để tôi mua cổ phần CSA, thì số tiền đó sẽ tự động được cộng trở lại vào số dư SNAP của tôi.",
            "MysignupInformation" : "Thông tin đăng ký của tôi và trạng thái thanh toán của tôi sẽ được chia sẻ với trang trại. Trang trại có thể liên hệ với tôi bằng thông tin tôi đã cung cấp trong yêu cầu CSA này.",
            "IAmResponsible" : "Tôi chịu trách nhiệm nhận cổ phần CSA của mình vào ngày và giờ do trang trại xác định hoặc nhờ người khác đến nhận cổ phần đó cho tôi. Địa điểm, ngày, và giờ nhận hàng có thể thay đổi bởi trang trại. Cổ phần CSA không được lấy sẽ được tặng và tôi sẽ không được hoàn lại tiền. Mọi sắp xếp giao hàng phải được thực hiện thông qua trang trại." ,
            "TheType" : "Loại, trọng lượng và số lượng sản phẩm sẽ thay đổi hàng tuần, và tôi không thể trả lại cổ phần CSA của mình để được hoàn lại tiền hoặc trao đổi.",
            "IfMySNAP" : "Nếu số tiền trợ cấp SNAP của tôi giảm và sẽ không còn chi trả toàn bộ chi phí cho cổ phần CSA của tôi, thì tôi có trách nhiệm thông báo cho trang trại. Nếu tôi chọn tiếp tục cổ phần CSA, tôi có thể sắp xếp một phương thức thanh toán thay thế để bù đắp phần chênh lệch.",
            "CSAShareDetails" : "Chi tiết cổ phần CSA và trải nghiệm khách hàng CSA của tôi do trang trại quản lý. Nếu có thắc mắc về những điều này, tôi có thể liên hệ với trang trại. DTA có quyền hủy bỏ cổ phần CSA của tôi theo yêu cầu của trang trại.",
            "IMayCancel" : "Tôi có thể hủy bỏ cổ phần CSA của mình bất kỳ lúc nào bằng cách:",
            "Submitting" : "Gửi yêu cầu hủy bỏ trên DTAFinder.com",
            "Calling" : "gọi cho đường dây HIP/CSA theo số 413-772-3411",
            "CancellationsMust" : "Việc hủy bỏ phải được nhận trước ngày 20 của tháng để có hiệu lực cho tháng tiếp theo. Nếu không, việc hủy bỏ có thể không xảy ra cho đến tháng sau đó.",
            "IMayBeAsked" : "Tôi có thể được yêu cầu hoàn thành một cuộc khảo sát ngắn về SNAP CSA Pilot.",
            "cancelCSAAgreement" : "HỦY BỎ THỎA THUẬN CSA",
            "signature" : "Chữ ký",
            "cancelSignatureErrMsg" : "Vui lòng nhập chữ ký của quý vị",
            "noteForCancelCSA" : "Lưu ý: Các cổ phần được chọn theo thỏa thuận này sẽ bị hủy bỏ",
            "description": "Mô tả",
            "WeightAmountOfGoods" :"Trọng Lượng/Số Lượng Hàng Hóa",
            "PickupDayTime" : "Ngày/Giờ Nhận Hàng",
            "validDayError":"Vui lòng nhập ngày hợp lệ từ 1 đến 31 ",
            "validYearError": "Vui lòng nhập năm hợp lệ",
            "PickA": "Chọn một",
            "shareBelow" : "cổ phần dưới đây. Trang này hiển thị số lượng SNAP và",
            "youGetEachMonth" : "quý vị nhận được mỗi tháng có thể được sử dụng để thanh toán SNAP CSA hàng tháng.",
            "IfYouNeedHelp": "Nếu quý vị cần trợ giúp, quý vị có thể yêu cầu chúng tôi gọi điện để tiếp tục yêu cầu CSA qua điện thoại.",
            "ThisPaymentSchedule": "Lịch trình thanh toán này được ước tính dựa trên ngày hôm nay. Ngày bắt đầu CSA và lịch trình thanh toán có thể diễn ra muộn hơn nếu trang trại cần nhiều thời gian hơn để xử lý yêu cầu CSA của quý vị.",
            "SelectPickupTime":"Chọn thời gian đến nhận",
            "Your":"Của quý vị",
            "YouMay":"Quý vị có thể muốn ",
            "download":"tải xuống thỏa thuận của quý vị",
            "reference":" để tham khảo trong tương lai.",
        }
    }
}